import React from "react"
import PropTypes from "prop-types"
import styles from "./portfolioCard.module.scss"

function PortfolioCard({
  emoji,
  image,
  title,
  description,
  role,
  techTags,
  link,
  featured,
  children,
}) {
  // Helper to categorize technologies and return matching status dot color
  const getTagClass = tag => {
    const t = tag.toLowerCase()
    if (t.includes("react") || t.includes("native") || t.includes("js"))
      return styles.react
    if (t.includes("node") || t.includes("express")) return styles.node
    if (t.includes("typescript") || t.includes("ts") || t.includes("flutter"))
      return styles.ts
    if (
      t.includes("mongodb") ||
      t.includes("redis") ||
      t.includes("sql") ||
      t.includes("db")
    )
      return styles.db
    if (t.includes("api") || t.includes("rest") || t.includes("concurrency"))
      return styles.api
    if (t.includes("saas") || t.includes("ocr") || t.includes("kyc"))
      return styles.saas
    return ""
  }

  return (
    <div className={`${styles.card} ${featured ? styles.featured : ""}`}>
      <div className={styles.cardInner}>
        <div className={styles.cardHeader}>
          {image ? (
            <div className={styles.logoWrapper}>
              <img
                src={image}
                alt={`${title} logo`}
                className={styles.logoImage}
              />
            </div>
          ) : emoji ? (
            <div className={styles.emojiWrapper}>
              <span className={styles.emoji}>{emoji}</span>
            </div>
          ) : null}
          <div>
            <h3 className={styles.title}>{title}</h3>
            {role && <p className={styles.role}>{role}</p>}
          </div>
        </div>

        <p className={styles.description}>{description}</p>

        <div className={styles.footer}>
          {techTags && techTags.length > 0 && (
            <div className={styles.tags}>
              {techTags.map((tag, i) => (
                <span key={i} className={styles.tag}>
                  <span className={`${styles.tagDot} ${getTagClass(tag)}`} />
                  {tag}
                </span>
              ))}
            </div>
          )}

          <div className={styles.actionContainer}>
            {children}
            {link && !children && (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.visitButton}
              >
                Visit Site <span className={styles.arrow}>→</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

PortfolioCard.propTypes = {
  emoji: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  role: PropTypes.string,
  techTags: PropTypes.arrayOf(PropTypes.string),
  link: PropTypes.string,
  featured: PropTypes.bool,
  children: PropTypes.node,
}

PortfolioCard.defaultProps = {
  featured: false,
}

export default PortfolioCard
